import {
  whiteColor,
  oceanBlueColor,
  DodgerBlueColor,
} from "../../cmsMainStyle";

const pilDetailFormStyle = (theme) => ({
  textField: {
    marginTop: theme.spacing(1),
    "& input:disabled": {
      color: "black",
    },
  },
  datePickerField: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
  box: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
  editSubHeader: {
    fontWeight: "bold",
  },
});

export { pilDetailFormStyle };
